export const Back = 'Zurück';
export const Retry = 'Versuchen Sie es erneut';
export const UnableDisplayDocument = 'Dokument kann nicht angezeigt werden';
export const DocumentLoadFailed = 'Dokument konnte nicht geladen werden. Versuchen Sie es erneut!';
export const DocumentMissing = 'Dokument fehlt! Kann nicht angezeigt werden';
export const LinkNotAvailable = 'Link nicht verfügbar!';
export const DocumentSigned = 'Das Dokument ist bereits signiert!';
export const MissingParams = 'Datensatz-ID oder Referenz fehlen';

